<template>
  <div>

    <div class="search-box mt-10">
      <el-form :inline="true" :model="formData" class="user-form-inline" size="mini">
        <el-form-item label="用户名">
          <el-input 
          v-model="formData.userName"
          clearable :readonly="isSearching"
          placeholder="请输入用户名" 
          style="width:120px"
          @keyup.enter.native="doSearch"
          @clear="doReset"
          @blur="doBlur"></el-input>
        </el-form-item>
        <el-form-item label="用户别名">
          <el-input 
          v-model="formData.memo"
          clearable :readonly="isSearching"
          placeholder="请输入用户别名" 
          style="width:130px"
          @keyup.enter.native="doSearch"
          @clear="doReset"
          @blur="doBlur"></el-input>
        </el-form-item>
        <el-form-item label="来源">
          <el-select 
            v-model="formData.collectType" 
            :readonly="isSearching" 
            placeholder="请选择来源" 
            style="width:100px">
            <el-option label="不限" value=""></el-option>
            <el-option label="Instagram" value="INS"></el-option>
            <el-option label="小红书" value="XHS"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属标签">
          <el-select
            v-model="formData.tagName"
            filterable
            remote
            clearable
            default-first-option
            placeholder="请输入选择"
            style="width:120px"
            no-data-text="找不到标签"
            @clear="doResetTagName"
            :remote-method="doSearchTag"
            :loading="isTagLoading">
            <el-option
              v-for="item in tagList"
              :key="item.tagId"
              :label="item.tagName"
              :value="item.tagName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="doSearch" :loading="isSearching">查询</el-button>
        </el-form-item>
      </el-form>

    </div>
    <el-divider></el-divider>
    <div style="background-color:#fff">
      <el-table
        :data="list"
        v-loading="isSearching"
        style="width: 100%"
        row-key="userId"
        border
        size="mini"
        @expand-change="getPosts">


        <el-table-column type="expand" label="展开" align="center">
          <template slot-scope="props">
            <div v-if="!props.row.collectFinish">
              数据未采集完毕, 请稍候再试.
              <template v-if="props.row.collectStatus == 'FAILED'">
                <el-button
                size="mini"
                type="warning"
                :loading="isReCollecting"
                @click="doReCollects(props.row)">重新采集</el-button>
              </template>
            </div>
            <div v-else>
              <PostingList :collectUserId="props.row.collectUserId" :collectType="props.row.collectType" :extension="props.row.extension||{}" :userData.sync="props.row" />
            </div>
          </template>
        </el-table-column>

        <el-table-column
          width="86"
          label="来源"
          align="center"
        >
          <template slot-scope="scope">
            <el-image class="logo" :src="logo[scope.row.collectType]"></el-image>
            <br/>
            <el-tag v-if="scope.row.collectFinish"
              type="success"
              size="mini"
              effect="dark">
              采集完成
            </el-tag>
            <el-tag v-else
              :type="$root.itemStatus[scope.row.collectStatus||''].type"
              size="mini"
              effect="dark">
              {{ $root.itemStatus[scope.row.collectStatus||''].text }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="fullName"
          label="用户名"
        >
          <template slot-scope="props">

            <div style="float:right" v-if="props.row.extension&&props.row.extension.se&&props.row.extension.se.syncType">
              <div v-if="props.row.extension.se.syncType=='USER'" >
                <i class="el-icon-timer" style="font-size:14px;" /> ({{ props.row.seTime }})
              </div>
              <div v-if="props.row.extension.se.syncType=='TAG'">
                <i class="el-icon-price-tag" style="font-size:14px;"/> ({{ props.row.seTime }})
              </div>
            </div>
            <div class="flex top">
              <div>
                <Avatar :src="props.row.headImgUrl" ></Avatar>
              </div>
              <div class="ml-10 mt-10">
                {{props.row.fullName}}
                <div v-if="props.row.tags">
                  <el-tag
                    v-for="item in props.row.tags"
                    :key="item.tagId"
                    :type="props.row.extension&&props.row.extension.se&&props.row.extension.se.syncType=='TAG'&&props.row.extension.se.tagId==item.tagId?'danger':''"
                    effect="dark"
                    size="mini">
                    {{ item.tagName }}
                  </el-tag>
                </div>
              </div>
            </div>
          </template>
        
        </el-table-column>

        <el-table-column
          prop="memo"
          label="关联喜悦汇账号"
          width="120"
          align="center"
        >
           <template slot-scope="props">
             <div v-if="props.row.slowLifeUserId">
                <Avatar :src="(props.row.customHeadImgUrl||'').split('?')[0]" />
                <p>{{props.row.memo}}</p>
             </div>
             <div v-else>
               <el-button type="info" size="mini" @click="doShowBindBox(props.row)" >绑定</el-button>
             </div>
             
           </template>
           
        </el-table-column>
        <el-table-column
          prop="createAt"
          label="创建时间"
          width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column 
          label="操作" 
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="doEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="doDelete(scope.$index, scope.row)">删除</el-button>

              <br/>
            <el-button
              class="mt-10"
              size="mini"
              type=""
              @click="doShowTaskList(scope.$index, scope.row)">查看任务日志</el-button>

          </template>
        </el-table-column>
      </el-table>

      <div class="ta-r pd-10-20">
        <el-pagination
          background
          hide-on-single-page
          layout="prev, pager, next"
          @current-change="doChangePage"
          :page-size="pagination.size"
          :current-page="pagination.page"
          :total="total">
        </el-pagination>
      </div>

    </div>


    <UserEdit :data="currentData" :show.sync="showFormEdit" />
    <UserBind :data.sync="currentData" :show.sync="isShowBindBox" />

<el-drawer
  :visible.sync="isShowTaskList"
  direction="ltr"
  size="50%"
  :withHeader="false"
  :close-on-press-escape="false"
  >
  <div class="pd-10-20"><TaskList :userId="currentData.userId" :updateFlag="isShowTaskList" /></div>
  

</el-drawer> 
    

  </div>
</template>

<script>
import PostingList from '@/components/PostingList';
import TaskList from '@/components/TaskList';
import UserEdit from '@/components/UserEdit';
import UserBind from '@/components/UserBind';
export default {
  name: 'User-List',
  components: {
    PostingList,UserEdit,UserBind,TaskList
  },
  data(){
    var tagName = this.$route.params.tagName || "";
    return {
      formData:{
        userName:"",
        collectType:"",
        modelType:"users",
        memo:"",
        tagName
      },
      collectStatus:{
        "":{text:"等待中",type:"info"},
        WAITING:{text:"等待中",type:"info"},
        QUEUE:{text:"排队中",type:"warning"},
        RUNNING:{text:"采集中",type:""},
        COMPLETED:{text:"已完成",type:"success"},
        FAILED:{text:"失败",type:"danger"},
      },
      isReCollecting:false,
      pagination:{
        size:10,
        page:1,
      },
      total:0,
      list:[],
      tagList:[],
      isSearching:false,
      isTagLoading:false,
      isShowTaskList:false,
      modelType:'users',
      showFormEdit:false,
      currentData:{userId:0},
      logo:{
        XHS:require('@/assets/common/logo_xhs.png'),
        INS:require('@/assets/common/logo_ins.png'),
      },
      isShowBindBox:false
    };
  },
  watch: {
    showFormEdit(newData){
      if(!newData){
        this.doSearch(false);
      }
    },
    isShowBindBox(newData){
      if(!newData){
        this.doSearch(false);
      }
    }
  },
  mounted () {
    this.doSearch();
  },
  methods: {
    doReCollects(userData){
      this.isReCollecting = true;
      this.request.post(`/api/v1/collectsTask/create?userId=${userData.userId}&updateOld=true`,{}).then(res=>{

        this.isReCollecting = false;
        if(!res){return ;}
        this.$message.success("操作成功!");
        this.doSearch(false);
      }).catch(error=>{
        this.isReCollecting = false;
        this.$message.error("返回超时,请稍候再试!");
        console.log(error);
      });
    },

    doShowBindBox(item){
      this.currentData = item;
      // this.$set(this.currentData,'userId',item.userId);
      this.isShowBindBox = true;
    },
    doEdit(index,row){
      this.currentData = this.$root.copy(row);
      this.showFormEdit = true;
    },
    doShowTaskList(index,row){
      this.currentData = this.$root.copy(row);
      this.isShowTaskList = true;
    },
    doDelete(index,row){
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        
        this.request.delete(`/api/v1/users/${row.userId}`).then(res=>{
          if(!res){return ;}
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          // this.doSearch(false);
        }).then(() => {
          this.doSearch(false);
        });
        
      })
      
    },
    doSearchTag(query){
      var tagName = query.replace(/(^\s*)|(\s*$)/g, "");
      this.isTagLoading = true;

      this.request.get(`/api/v1/tags?page=1&size=5&tagName=${tagName}`).then(res=>{
        this.isTagLoading = false;
        this.tagList = [];
        if(!res || !res.results){return ;}
        this.tagList = res.results;
      });
    },

    getPosts(){
      console.log(arguments)
    },

    getList(url){
      this.isSearching = true;
      this.request.get(url).then(res=>{
        this.isSearching = false;
        this.list = [];
        this.total = 0;
        this.pagination.page = 1;
        if(!res){return ;}
        this.list = res.results || [];
        this.list.forEach(d=>{
          var seTime = '';
          if(d.extension && d.extension.se && d.extension.se.syncType){
            if(d.extension.se.syncType == 'TAG'){
              var temp = d.tags.find(t=>{
                if(t.extension && t.extension.se && t.extension.se.payload && t.extension.se.payload.startAt){
                  return t;
                } else return false;
              });
              if(temp){
                seTime = temp.extension.se.payload.startAt+'~'+temp.extension.se.payload.endAt;
              }
            } else if(d.extension.se.syncType == 'USER'){
              if(d.extension.se.payload && d.extension.se.payload.startAt){
                seTime = d.extension.se.payload.startAt+'~'+d.extension.se.payload.endAt;
              }
              
            } 
          }
          this.$set(d,'seTime',seTime);
        })
        this.total = res.total;
        // this.total = 646;
        this.pagination.page = res.page;

      });
    },
    doSearch(resetPage = true){
      // if(!this.formData.collectUserName){
      //   this.$message.warning("搜索内容不能为空");
      //   return ;
      // }
      

      var formData = {...this.pagination,...this.formData};
      if(resetPage){formData.page = 1;}
      var params = this.$root.object2urlparams(formData);


      this.getList(`/api/v1/users?${params}`);
      
    },
    doChangeCollectType(){
      if(!this.formData.collectUserName){return ;}
      this.doSearch(false);
    },
    doChangePage(currentPage){
      var formData = {...this.pagination,...this.formData};
      formData.page = currentPage;
      var params = this.$root.object2urlparams(formData);
      this.getList(`/api/v1/users/?${params}`);
    },
    doBlur(){
      // if(!this.formData.collectUserName){this.doReset();}
    },
    doReset(){
      this.list = [];
      this.total = 0;
      this.pagination.page = 1;
      this.doSearch();
      // this.formData.collectType = 'INS';
    },
    doResetTagName(){
      if(this.$route.params.tagName){
        this.$router.push('/Home/Collect/User/List/');
      }
      this.doReset();
    },
  }
}
</script>
<style lang="less" scoped>
.logo{
  width:20px;
  vertical-align: middle;
}
</style>
<style lang="less">
.user-form-inline{
  .search-box{
    .el-select .el-input{
      width:160px;
    }
  }
}
</style>